const TopicTwo = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1> Payment protection </h1>
        <p>
          Read about our various premium payment security features to protect your payment transactions.
        </p>
      </div>
    </div>
  );
};

export default TopicTwo;
